import {
  BatchRequestProperties,
  BatchIdSerializer,
  BatchItemProcessor,
  DefaultProcessBatchWaitTime
} from './batchRequestConstants';
import { createExponentialBackoffCooldown } from './batchRequestUtil';
import BatchRequestProcessor from './batchRequestProcessor';

class BatchRequestProcessorFactory {
  public readonly createExponentialBackoffCooldown = createExponentialBackoffCooldown;

  createQueueProcessor(
    itemsProcessor: BatchItemProcessor,
    itemSerializer: BatchIdSerializer,
    properties: BatchRequestProperties
  ) {
    const batchRequestProcessor = new BatchRequestProcessor();
    return {
      queueItem: (item: number) => {
        return batchRequestProcessor.queueItem(item, itemsProcessor, itemSerializer, properties);
      },
      invalidateItem: (item: number) => {
        return batchRequestProcessor.invalidateItem(item, itemSerializer);
      }
    };
  }

  createRequestProcessor(
    itemsProcessor: BatchItemProcessor,
    itemSerializer: BatchIdSerializer,
    properties: BatchRequestProperties
  ) {
    if (!properties.processBatchWaitTime) {
      properties.processBatchWaitTime = DefaultProcessBatchWaitTime;
    }
    return this.createQueueProcessor(itemsProcessor, itemSerializer, properties);
  }
}

export default new BatchRequestProcessorFactory();
